import { render, staticRenderFns } from "./seatDetail.vue?vue&type=template&id=beb68edc"
import script from "./seatDetail.vue?vue&type=script&lang=js"
export * from "./seatDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports